import React, { useEffect, useMemo, useRef, useState } from "react";
import { HsnReport } from "../../services/Report/ReportServices";
import { Modal } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";

const CRHSN = ({ resPacket, startDate, endDate }) => {
  const [show, setShow] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});

  useEffect(() => {
    if (!show) {
      setItemList([]);
      setSelectedItem({});
    }
  }, [show]);

  const getTotalAmount = () => {
    return resPacket?.reduce((acc, item) => {
      return acc + item.totalAmountWithTax;
    }, 0);
  };

  const getHsnReportById = (item) => {
    setSelectedItem(item);
    var request = {
      startDate: startDate,
      endDate: endDate,
      hsnCode: item.hsnSac,
    };
    HsnReport(request).then((res) => {
      setItemList(res.responsePacket);
      setShow(true);
    });
  };

  const totals = useMemo(() => {
    const totalAmount = itemList.reduce((acc, item) => {
      if (item.discountType === "Percentage") {
        return (
          acc +
          (item.itemAmount * (1 - item.discountValue / 100) + item.itemTaxAmt)
        );
      } else if (item.discountType === "Amount") {
        return acc + (item.itemAmount - item.discountValue + item.itemTaxAmt);
      } else {
        return acc + (item.itemAmount + item.itemTaxAmt);
      }
    }, 0);
    const totalTaxAmount = itemList.reduce(
      (acc, item) => acc + item.itemTaxAmt,
      0
    );
    const totalItemAmount = itemList.reduce((acc, item) => {
      if (item.discountType === "Percentage") {
        return acc + item.itemAmount * (1 - item.discountValue / 100);
      } else if (item.discountType === "Amount") {
        return acc + (item.itemAmount - item.discountValue);
      } else {
        return acc + item.itemAmount;
      }
    }, 0);
    const totalQuantity = itemList.reduce(
      (acc, item) => acc + item.quantity,
      0
    );
    const totalCrQuanity = itemList.reduce((acc, item) => acc + item.creditNoteQuantity, 0)
    const totalSettlementAmount = itemList.reduce((acc, item) => {
      if (item.creditNoteNumber !== "NotGenerated") {
        acc += item.settlementAmount;
      }
      return acc;
    }, 0);

    return {
      totalAmount: totalAmount.toFixed(2),
      totalTaxAmount: totalTaxAmount.toFixed(2),
      totalItemAmount: totalItemAmount.toFixed(2),
      totalQuantity: totalQuantity.toFixed(2),
      totalCrQuanity: totalCrQuanity.toFixed(2),
      totalSettlementAmount: totalSettlementAmount.toFixed(2)

    };
  }, [itemList]);

  const componentRef = useRef();
  const handleReactToPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePrint = () => {
    setTimeout(() => {
      handleReactToPrint();
    }, 1000);
  };

  const showDiscount = (value) => {
    if (value.discountType === "Percentage") {
      return Number(value.discountValue)?.toFixed(2) + " %";
    } else if (value.discountType === "Amount") {
      return Number(value.discountValue)?.toFixed(2);
    } else {
      return Number(value.discountValue)?.toFixed(2);
    }
  };

  const showDiscountedAmount = (value) => {
    if (value.discountType === "Percentage") {
      const total = value.itemAmount * (1 - value.discountValue / 100);
      return Number(total)?.toFixed(2);
    } else if (value.discountType === "Amount") {
      const total = value.itemAmount - value.discountValue;
      return Number(total)?.toFixed(2);
    } else {
      return Number(value.itemAmount)?.toFixed(2);
    }
  };

  const showSubTotalAmount = (value) => {
    if (value.discountType === "Percentage") {
      const total =
        value.itemAmount * (1 - value.discountValue / 100) + value.itemTaxAmt;
      return Number(total)?.toFixed(2);
    } else if (value.discountType === "Amount") {
      const total = value.itemAmount - value.discountValue + value.itemTaxAmt;
      return Number(total)?.toFixed(2);
    } else {
      return Number(value.itemAmount + value.itemTaxAmt)?.toFixed(2);
    }
  };

  return (
    <div>
      {resPacket && resPacket.length > 0 ? (
        <div className="customTable" id="scroll">
          <table className="customTable w-100">
            <thead className="fixed-thead">
              <tr>
                <th>SNO.</th>
                <th className="pl-4">HSN</th>
                <th className="pl-4">DESCRIPTION</th>
                <th className="pl-4">UQC</th>
                <th className="pl-4">TOTAL QUANTITY</th>
                <th className="pl-4">TOTAL VALUE</th>
                <th className="pl-4">TAXABLE VALUE</th>
                <th className="pl-4">INTEGRATED TAX</th>
                <th className="pl-4">CENTRAL TAX</th>
                <th className="pl-4">STATE/UT TAX</th>
                <th className="pl-4">CESS AMOUNT</th>
                <th className="pl-4">TAX AMOUNT</th>
                <th className="pl-4">RATE</th>
              </tr>
            </thead>
            <tbody className="body-scroll-custom">
              {resPacket.map((row, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td
                    onClick={() => getHsnReportById(row)}
                    className="item-title-blue"
                    style={{ cursor: "pointer" }}
                  >
                    {row.hsnSac}
                  </td>
                  <td></td>
                  <td>{row.itemUnit}</td>
                  <td>{row.quantity}</td>
                  <td>{row.totalAmountWithTax}</td>
                  <td>{row.taxableAmount}</td>
                  <td>{row.igstAmount}</td>
                  <td>{row.cgstAmount}</td>
                  <td>{row.sgstAmount}</td>
                  <td>{ }</td>
                  <td>{row.totalTax}</td>
                  <td>{row.taxRate}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4}></td>
                <td>{getTotalAmount()}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      ) : (
        <div className="my-3 text-black text-center">No Records Found</div>
      )}
      {/* <Modal size="xl" className="modal-size-custom" show={show} onHide={() => setShow(false)} >
        <div className="d-flex justify-content-between mt-3 mx-4">
          <h3 className="font-size-20">HSN Item Report</h3>
          <button className="btn hoverBtn p-1" onClick={handlePrint}>
            <LocalPrintshopOutlinedIcon style={{ fontSize: "22px" }} />
          </button>
        </div>
        <Modal.Body >
          <div
            className="custom-table-div standardTable"
            ref={componentRef}
            id="pdf"
            style={{ margin: "15px", color: "black" }}
          >
            <div className="row p-3 align-items-center">
              <div className="col-5">
                <h2 className="font-size-18 font-weight-bold">
                  {itemList && itemList.length > 0 && (
                    <span>
                      {itemList[0].itemTitle} ({itemList[0].hsnSac})
                    </span>
                  )}
                </h2>
              </div>
              <div className="col-7">
                <div className="d-flex justify-content-end align-items-center">
                  <span className="mr-5">Start Date: {startDate}</span>
                  <span>End Date: {endDate}</span>
                </div>
              </div>
            </div>
            <hr style={{ backgroundColor: "#ececec" }} />
            <div>
              {itemList?.length > 0 ? (
                <>
                  <div className="">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>SNO.</th>
                          <th>Invoice No.</th>
                          <th>Invoice Date</th>
                          <th>Quantity</th>
                          <th>Item Unit</th>
                          <th>Rate</th>
                          <th>Discount</th>
                          <th>Amount</th>
                          <th>Tax Rate(%)</th>
                          <th>Tax Amount</th>
                          <th>Total Amount</th>
                          <th>CN-No.</th>
                          <th>CN-Quantity</th>
                          <th>CN-Rate</th>
                          <th>CN-Tax</th>
                          <th>CN-Amt</th>
                          <th>Settlement Amt</th>
                        </tr>
                      </thead>

                      <tbody>
                        {itemList.map((a, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{a.invoiceNo}</td>
                            <td>{a.invoiceDate}</td>
                            <td>{Number(a.quantity)?.toFixed(2)}</td>
                            <td>{a.itemUnit}</td>
                            <td>{Number(a.itemRate)?.toFixed(2)}</td>
                            <td>{showDiscount(a)}</td>
                            <td>{showDiscountedAmount(a)}</td>
                            <td>{Number(a.itemTaxRate)?.toFixed(2)}</td>
                            <td>{Number(a.itemTaxAmt)?.toFixed(2)}</td>
                            <td>{showSubTotalAmount(a)}</td>
                            <td>{(a.creditNoteNumber === "NotGenerated"||a.creditNoteQuantity<1) ? "-" : a.creditNoteNumber}</td>
                            <td>{a.creditNoteQuantity}</td>
                            <td>{a.creditNoteRate}</td>
                            <td>{a.creditNoteTax}</td>
                            <td>{a.creditNoteAmount}</td>
                            <td>{a.settlementAmount}</td>
                          </tr>
                        ))}
                        <tr>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom">
                            <b>{totals.totalQuantity}</b>
                          </td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom">
                            <b>{totals.totalItemAmount}</b>
                          </td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom">
                            <b>{totals?.totalCrQuanity}</b>
                          </td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom"></td>
                          <td className="border-bottom">
                            <b>{totals?.totalSettlementAmount}</b>
                          </td>
                        </tr>

                        <tr>
                          <td></td>
                          <td colSpan={6}>
                            <b>Total</b>
                          </td>
                          <td colSpan={2}>
                            <b>{totals.totalItemAmount}</b>
                          </td>
                          <td>
                            {" "}
                            <b>{totals.totalTaxAmount}</b>
                          </td>
                          <td>
                            <b>{totals.totalAmount}</b>
                          </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </>
              ) : (
                <>No Record found</>
              )}
            </div>
          </div>

        </Modal.Body>
      </Modal> */}
    </div>
  );
};

export default CRHSN;
